import axios, { type AxiosRequestConfig } from 'axios';
import { makeBinded } from '../lib/makeBinded';
import type { UnknownArray, UnknownRecord } from 'type-fest';
import { type HttpInterceptorOptions, HttpInterceptorsService } from './http-interceptors.service';

const AXIOS = axios.create();

export class HttpService {
  protected http = AXIOS;
  protected interceptors: InstanceType<typeof HttpInterceptorsService> | undefined;

  setInterceptors(options: HttpInterceptorOptions) {
    this.interceptors = new HttpInterceptorsService(AXIOS, options);
  };

  async get<ResDTO>(url: string, config?: AxiosRequestConfig) {
    return this.http.get<ResDTO>(url, config) as ResDTO;
  }

  async post<ResDTO>(url: string, body: UnknownRecord | UnknownArray | FormData | File, config?: AxiosRequestConfig) {
    return this.http.post<ResDTO>(url, body, config) as ResDTO;
  }

  async put<ResDTO>(url: string, body: UnknownRecord | UnknownArray | FormData | File, config?: AxiosRequestConfig) {
    return this.http.put<ResDTO>(url, body, config) as ResDTO;
  }

  async patch<ResDTO>(url: string, body: UnknownRecord | UnknownArray | FormData | File, config?: AxiosRequestConfig) {
    return this.http.patch<ResDTO>(url, body, config) as ResDTO;
  }

  async delete<ResDTO>(url: string, config?: AxiosRequestConfig) {
    return this.http.delete<ResDTO>(url, config) as ResDTO;
  }
}

export const httpService = makeBinded(HttpService)();
